import axios from "axios";
import config from "@/config.json";

function geUrl() {
  const env = window.location.origin;

  if (
    window.location.hostname === "localhost" &&
    window.location.port &&
    window.location.port !== "8080" &&
    config.local
  ) {
    return config.local;
  }

  if (env.includes("pre") && config.pre) return config.pre;
  if (env.includes("pro") && config.pro) return config.pro;

  return env;
}
export const url = geUrl();

export default axios.create({
  baseURL: `${url}/api/v1`,
  headers: {
    "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT, OPTIONS",
    "Content-Type": "application/json",
  },
});
